import { render, staticRenderFns } from "./GoalFilter.vue?vue&type=template&id=63633e06"
import script from "./GoalFilter.vue?vue&type=script&lang=ts"
export * from "./GoalFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports